export default "__VITE_ASSET__d63f70a6__"